import type { WsInboundEnvelope } from "./wsInboundEnvelope";
import { optCallerId, optFiniteNumber, optString } from "./wsPayloadCoercion";

export interface IncomingGroupCallWsPayload {
  type: "incoming_group_call";
  call_id: string;
  caller_id: number;
  thread_id?: string;
  thread_name?: string;
  participant_count?: number;
  caller_name?: string;
  caller_avatar?: string;
  /** Raw string from server; handler narrows to `CallType`. */
  call_type?: string;
  timestamp?: string;
}

/** Validated only for `incoming_group_call`. */
export function parseIncomingGroupCallPayload(
  envelope: WsInboundEnvelope,
): IncomingGroupCallWsPayload | null {
  if (envelope.type !== "incoming_group_call") return null;
  const call_id = optString(envelope.call_id);
  if (!call_id) return null;

  const o = envelope;
  return {
    type: "incoming_group_call",
    call_id,
    caller_id: optCallerId(o.caller_id) ?? 0,
    thread_id: optString(o.thread_id),
    thread_name: optString(o.thread_name),
    participant_count: optFiniteNumber(o.participant_count),
    caller_name: optString(o.caller_name),
    caller_avatar: optString(o.caller_avatar),
    call_type: optString(o.call_type),
    timestamp: optString(o.timestamp),
  };
}
